import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { IconEye, IconEyeOff } from '../components/icons';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(identifier, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-visual" aria-hidden="true">
        <img className="login-visual-image" src="/spa-images/saanti-070.webp" alt="" />
        <div className="login-visual-copy">
          <span className="login-eyebrow">SAANTI · SAANTI BOUTIQUE · NIRANA</span>
          <h1>Care in every detail.</h1>
          <p>One calm place to manage bookings, guests, therapists, and all three properties.</p>
        </div>
      </section>

      <main className="login-panel">
        <form className="login-box" onSubmit={submit}>
          <div className="login-logo" aria-label="SAANTI, SAANTI Boutique and NIRANA">
            <div className="login-logo-trio">
              <span className="login-brand-mark saanti">
                <img
                  src="/spa-images/saanti-official-logo.png"
                  alt="SAANTI Thai Massage"
                />
              </span>
              <i className="login-brand-divider" aria-hidden="true" />
              <span className="login-brand-mark boutique" aria-label="SAANTI Boutique">
                <img src="/spa-images/saanti-boutique-logo.png" alt="" aria-hidden="true" />
              </span>
              <i className="login-brand-divider" aria-hidden="true" />
              <span className="login-brand-mark nirana">
                <img
                  src="/spa-images/nirana-master-wordmark.png"
                  alt="NIRANA Massage and Spa"
                />
              </span>
            </div>
            <span className="login-product">STAFF POS</span>
          </div>

          <div className="login-heading">
            <h1>ยินดีต้อนรับกลับ</h1>
            <p>เข้าสู่ระบบเพื่อจัดการร้านและการจอง</p>
          </div>

          {error && <div className="login-error" role="alert">{error}</div>}

          <label className="login-field">
            <span>บัญชีผู้ใช้</span>
            <input
              className="login-input"
              placeholder="เบอร์โทร / Email / User ID"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </label>

          <label className="login-field">
            <span>รหัสผ่าน</span>
            <span className="login-password">
              <input
                className="login-input"
                type={showPassword ? 'text' : 'password'}
                placeholder="กรอกรหัสผ่าน"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-eye"
                aria-label={showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'}
                aria-pressed={showPassword}
                onClick={() => setShowPassword((s) => !s)}
              >
                {showPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
              </button>
            </span>
          </label>

          <button className="login-submit" type="submit" disabled={busy}>
            <span>{busy ? 'กำลังเข้าสู่ระบบ…' : 'เข้าสู่ระบบ'}</span>
            {!busy && <span className="login-submit-arrow" aria-hidden="true">→</span>}
          </button>

          <p className="login-private">
            <span aria-hidden="true" /> ระบบสำหรับพนักงาน SAANTI, SAANTI Boutique และ NIRANA เท่านั้น
          </p>
        </form>
      </main>
    </div>
  );
}
